// Google Translate gets some short matrimony UI words wrong in Tamil. Once Google has translated the page, this
// swaps those known-bad results for the right Tamil term. Add a line whenever you spot another wrong word:
//   EXACT    - used when the whole text of an element is the wrong word (safe for words with other meanings)
//   CONTAINS - used when the wrong word appears inside longer text (longest entries first)
const EXACT = [
    ['வீடு', 'முகப்பு'],              // "Home" (nav) came out as "house"
    ['வீடு »', 'முகப்பு »'],
    ['போட்டி', 'பொருத்தம்'],         // "Match" came out as "contest"
    ['போட்டிகள்', 'பொருத்தங்கள்'],    // "Matches"
    ['குறுகிய பட்டியல்', 'தெரிவுப்பட்டியல்'], // "Shortlist"
];

const CONTAINS = [
    ['சிறப்பு போட்டிகள்', 'சிறப்புப் பொருத்தங்கள்'], // "Featured Matches"
    ['குறுகிய பட்டியலில்', 'தெரிவுப்பட்டியலில்'],
    ['குறுகிய பட்டியல்', 'தெரிவுப்பட்டியல்'],
    ['பொருத்த போட்டி', 'பொருத்தம்'],
];

const exactMap = new Map(EXACT);

const fixText = text => {
    const trimmed = text.trim();
    if (!trimmed) return text;
    if (exactMap.has(trimmed)) return text.replace(trimmed, exactMap.get(trimmed));
    let next = text;
    for (const [wrong, right] of CONTAINS) {
        if (next.includes(wrong)) next = next.split(wrong).join(right);
    }
    return next;
};

const fixTree = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
        const parent = node.parentElement;
        if (parent && !parent.closest('.notranslate, script, style, textarea, input')) {
            const fixed = fixText(node.nodeValue);
            if (fixed !== node.nodeValue) node.nodeValue = fixed;
        }
        node = walker.nextNode();
    }
};

// Keeps fixing as Google (and React) change the page. Returns a stop function.
export const startTamilGlossary = () => {
    let frame = 0;
    const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; observer.disconnect(); fixTree(document.body); observe(); });
    };
    const observer = new MutationObserver(schedule);
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    fixTree(document.body);
    observe();
    return () => { observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
};
